var exports = {
  "Jv": "AutoPlayVideo__T7OS2X",
  "Ce": "Video__rBESzJ",
  "DM": "PlayButton__yVNfjC",
  "sY": "PlayButtonIcon__o43eai",
  "s6": "VisuallyHidden__KT5ffL",
};

module.exports = exports;
